import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/tagLists'
import Component from 'components/TagLists'

export default createListViewContainer({ actions, selectors: selectors.tagLists })(Component)
